var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',{attrs:{"label":_vm.requiredCharLabel,"name":_vm.nameInput,"color":"success","hide-details":"auto","underlined":"","dense":"","rows":"3","rules":_vm.rule,"error-messages":_vm.errorMessages,"counter":_vm.counter,"disabled":_vm.disabled},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }